import React from 'react';

/**
 * KanAIStatusLine — EN rad med spinner och en text som uppdateras löpande
 * medan KanAI arbetar ("Söker i kunskapsbasen: schakt", "Läser dokument",
 * "Skriver svar"). Ersätter tänk-orben och verktygsspåret med en rad per
 * verktyg (Mikael 2026-10-14: snyggt i demo, rörigt i verkligheten).
 *
 * Texten byts in place: ingen ny rad, ingen historik. Historiken finns
 * kvar under det färdiga svaret som "N verktyg använda".
 *
 * @param {object} props
 * @param {string} [props.text] - aktuell status. Default "KanAI tänker"
 */
export default function KanAIStatusLine({ text }) {
  const label = (text && String(text).trim()) || 'KanAI tänker';
  return (
    <div className="kp-kanai-statusline" role="status" aria-live="polite">
      <span className="kp-kanai-statusline__spinner" aria-hidden="true" />
      <span className="kp-kanai-statusline__text">{label}</span>
    </div>
  );
}
